import React from 'react'

import { classes } from '../utils'

interface TwoColumnProps {
  firstColumnTitle?: string
  firstColumnContent?:
    | string
    | React.ReactNode
    | React.ReactElement
    | JSX.Element
  children: React.ReactNode
  containerClassName?: string
  firstColumnContainerClassName?: string
}

export const TwoColumn = ({
  containerClassName,
  firstColumnTitle,
  firstColumnContent,
  firstColumnContainerClassName,
  children,
}: TwoColumnProps) => {
  return (
    <div
      className={classes(
        'py-5 md:grid md:grid-cols-12 md:gap-6',
        containerClassName,
      )}
    >
      <div className="md:col-span-4">
        <div className={classes('px-4 sm:px-0', firstColumnContainerClassName)}>
          {firstColumnTitle && (
            <h2 className="font-sans text-2xl font-medium leading-7">
              {firstColumnTitle}
            </h2>
          )}
          {typeof firstColumnContent === 'string' ? (
            <p className="mt-2 font-sans text-foreground-subtle">
              {firstColumnContent}
            </p>
          ) : (
            <div className="mt-2 font-sans text-foreground-subtle">
              {firstColumnContent}
            </div>
          )}
        </div>
      </div>
      <div className="mt-5 md:col-span-7 md:col-start-6 md:mt-0">
        {children}
      </div>
    </div>
  )
}
